import { INotifications } from 'common/layouts/Default/models';
import { IPage } from 'common/models';
import API from 'services/api';

export const getNotifications = ({
  isSent,
}: {
  isSent?: boolean;
}): Promise<IPage<INotifications>> =>
  API.get('/api/notifications', { params: isSent ? { IsSent: isSent } : undefined })?.then(
    res => res?.data,
  );
